import { Button, Drawer, Modal, message, Grid } from "antd";
import React, { useEffect, useState } from "react";
import { useProcessIdea } from "../_actions/bot";
import log from "cslog";
import DesignCanvasList from "../ai_home/DesignCanvasList";
import { useSingleItem } from "../_actions/app/items";
import { MessageCodeView } from "../ai_home/ChatBox";
import { CloseOutlined } from "@ant-design/icons";
import { BackgroundColor } from "@tiptap/extension-text-style";
import OneCanvasWrapper from "../qmade/creator/OneCanvasWrapper";
import LoadingLottie from "../common/LoadingLottie";
import IdeaLoadingLottie from "../media/animations/idea_loading.json";
import TokenManagerModal from "../finance/TokenManagerModal";

function IdeaCanvasModal({ data, me, open, setOpen }) {
    // const [open, setOpen] = useState(false);
    // const [item, setItem] = useState(data);
    log.d(me, "Idea Canvas ME");
    const [item, setItem] = useState(null);
    const [openTokenModal, setOpenTokenModal] = useState(false);
    const { useBreakpoint } = Grid;
    const screens = useBreakpoint();
    const isMobile = !screens.sm;
    const {
        isLoading: loadingItem,
        isSuccess: successItem,
        data: dataItem,
        refetch: refetchItem,
    } = useSingleItem(
        "qdb_calendar_entries",
        `/${data.id}?fields=*,platforms.*`,
        !!data?.id
    );
    const mutationProcessIdea = useProcessIdea((result) => {
        log.d(result, "Gen Calendar Result");
        if (
            result?.data?.success === false &&
            result?.data?.error?.code === "TOKEN_INSUFFICIENT"
        ) {
            message.error(result?.data?.error?.msg);
            setOpenTokenModal(true);
        }
        refetchItem();
    });
    const [open_cust, setOpenCust] = useState(true);
    const [messageApi, contextHolder] = message.useMessage();

    log.d(data, "Data in Idea Canvas Modal");
    log.d(dataItem, "dataItem in Idea Canvas Modal");
    log.d(item, "item in Idea Canvas Modal");

    // useEffect(() => {
    //     if (successItem) {
    //         setItem(dataItem);
    //         if (dataItem?.status != "generated" && !loadingItem) {
    //             log.p("Now processing in Idea Canvas Modal");
    //             mutationProcessIdea.mutate({
    //                 id: dataItem.id,
    //             });
    //         }
    //     }
    // }, [data, successItem, dataItem]);
    useEffect(() => {
        if (!successItem || !dataItem) return;
        setItem(dataItem);
        if (
            dataItem?.status !== "generated" &&
            !loadingItem &&
            !mutationProcessIdea.isLoading &&
            !mutationProcessIdea.isSuccess &&
            !mutationProcessIdea.isError
        ) {
            log.p("now processing in idea canvas modal");
            mutationProcessIdea.mutate({ id: dataItem.id });
        }
    }, [
        successItem,
        dataItem,
        loadingItem,
        mutationProcessIdea.isLoading,
        mutationProcessIdea.isSuccess,
        mutationProcessIdea,
    ]);

    useEffect(() => {
        if (!data?.id) {
            if (data.status === "generated") {
                if (data?.generated_data?.error) {
                    message.error(data?.generated_data?.message);
                } else {
                    setItem(data);
                }
            }
        }
        if (!data) return;
        if (data?.status === "generated") {
            if (data?.generated_data?.error) {
                message.error(data?.generated_data?.message);
            } else {
                setItem(data);
            }
        }
    }, [data]);

    return (
        <>
            {/* {trigger && <span onClick={() => setOpen(true)}>{trigger}</span>} */}

            {/* <OneCanvasWrapper
            // trigger={<Button>Hello world</Button>}
            open={open}
            setOpen={setOpen}
            title="Canvas"
            isMobile={false}
        > */}

            {contextHolder}
            <CanvasWrapper
                open={open}
                setOpen={setOpen}
                title="Canvas"
                actions={[
                    <Button
                        size={isMobile ? "large" : "middle"}
                        block={isMobile}
                    >
                        Download
                    </Button>,
                ]}
                width={open_cust ? "80vw" : "56vw"}
            >
                {/* <div style={{
                display: "flex",
                flexDirection: "row",
                height: "100%"
            }}>
                <div style={{
                    width: "450px",
                    boxSizing: "border-box"
                }}>
                    Panel
                </div>
                <div style={{ flex: 1 }}> */}
                {/* <p>Current status: {item.status}</p> */}
                {/* <pre>{JSON.stringify(item, null, 2)}</pre> */}
                {item?.status !== "generated" &&
                    !mutationProcessIdea.isLoading && (
                        <div
                            style={{
                                height: "100vh",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <p>Failed to generate content</p>
                            <Button
                                onClick={() => {
                                    mutationProcessIdea.mutate({
                                        id: item.id,
                                    });
                                }}
                                loading={mutationProcessIdea.isLoading}
                                size={isMobile ? "large" : "middle"}
                                block={isMobile}
                            >
                                Retry
                            </Button>
                        </div>
                    )}
                {/* {mutationProcessIdea.isLoading && <p>Generating content....</p>} */}
                {mutationProcessIdea.isLoading && (
                    <LoadingLottie
                        file={IdeaLoadingLottie}
                        style={{
                            width: 400,
                            height: 310,
                            marginTop: "-20px",
                        }}
                        wrapper_style={{
                            minHeight: "100vh",
                            width: "100%",
                        }}
                        text="Processing idea..."
                        text_style={{ fontSize: "1.2em", color: "gray" }}
                    />
                )}
                {/* <MessageCodeView  default_show={false} data={{  language: "json",  message: "Item", code: item }} /> */}
                {item?.status === "generated" && (
                    <DesignCanvasList
                        // data={data?.generated_data?.canvas}
                        data={prepareForCanvas(item?.generated_data?.canvas)}
                        // history_id={item?.generated_data?.history_id}
                        entry_id={item?.id}
                        me={me}
                        isMobile={isMobile}
                        closeBtn={
                            <Button
                                color="default"
                                // type="text"
                                icon={<CloseOutlined />}
                                onClick={() => setOpen(false)}
                            />
                        }
                        close_left={true}
                        open_cust={open_cust}
                        setOpenCust={setOpenCust}
                        platforms={item?.platforms}
                        modifications={item?.modifications || {}}
                        devs={{
                            entry_id: item?.id,
                            preset_id: "abcd",
                        }}
                        close={() => setOpen(false)}
                    />
                )}
                {/* </div>
            </div> */}
            </CanvasWrapper>
            <TokenManagerModal
                selected_org={me?.selected_org?.id}
                open={openTokenModal}
                onClose={() => setOpenTokenModal(false)}
            />

            {/* </OneCanvasWrapper> */}
        </>
    );
}

// function CanvasWrapper({ children, open, setOpen, title, actions = [] }) {
//     return <Drawer
//         // title="Canvas"
//         placement="right"
//         closable={false}
//         // closable={{ 'aria-label': 'Close Button' }}
//         onClose={() => setOpen(false)}
//         open={open}
//         size="large"
//         extra={actions}
//         styles={{
//             body: {
//                 padding: 10,
//             }
//         }}
//         // width={"70vw"}
//         width={"60vw"}
//     >{children}</Drawer>
// }

export function CanvasWrapper({
    children,
    open,
    setOpen,
    title,
    actions = [],
    width = "60vw",
    bottom_panel = null,
}) {
    const { useBreakpoint } = Grid;
    const screens = useBreakpoint();
    const isMobile = !screens.sm;

    if (isMobile) {
        return (
            <Drawer
                // title="Canvas"
                placement="bottom"
                // closable={false}
                // closable={{ 'aria-label': 'Close Button' }}
                onClose={() => setOpen(false)}
                open={open}
                // size="large"
                size="100%"
                extra={actions}
                styles={{
                    body: {
                        // padding: 10,
                        padding: "10px 0 10px 0",
                    },
                }}
                key="qureal_preview_drawer"
                height="100%"
                closeIcon={false}
                footer={bottom_panel}
            >
                {children}
            </Drawer>
        );
    }
    return (
        <Drawer
            // title="Canvas"
            placement="right"
            closable={false}
            // closable={{ 'aria-label': 'Close Button' }}
            onClose={() => setOpen(false)}
            open={open}
            // size="large"
            size={width}
            extra={actions}
            styles={{
                body: {
                    // padding: 10,
                    padding: "0px 0px 10px 0px",
                },
            }}
            width={width}
            footer={bottom_panel}
        >
            {children}
        </Drawer>
    );
}

export default IdeaCanvasModal;

export function prepareForCanvas(canvas_data) {
    const key = Object.keys(canvas_data)[0];
    const value = canvas_data[key];
    // const prefill= value?.prefill.....
    return {
        type: key,
        data: value,
    };
}

// this is demo commit
